<template>
  <div id="footer" class="footer_fundo">
      <div class="p-grid">
          <div class="p-col-12 p-lg-4 p-md-4 p-mt-4">
              <img src="../src/assets/logo-jurisprudencia-rodape.png" alt="babylon-layout" class="footer-logo">
              <br/>
              <span style="color:#ffffff; font-size:1rem; padding-left:5rem;">{{ambiente}}</span>
          </div>

          <div class="p-col-12 p-lg-8 footer-menu">
              <div class="p-grid">
                  <div class="p-col-12 p-md-6 p-lg-5 p-mt-4">
                      <span style="color:#ffffff; font-size:1.5rem;">Portais</span>

                      <a href="#primefaces">Portal TCE AM</a>

                      <a href="#prime">Portal Transparência</a>

                      <a href="#testimonials">Diário Oficial Eletrônico - DOE</a>

                     
                  </div>
                  <div class="p-col-12 p-md-6 p-lg-5 p-mt-4">
                      <span style="color:#ffffff; font-size:1.5rem;">Sistemas</span>

                      <a href="#vue">e-Contas</a>
                      

                  </div>
                                </div>
          </div>
           
      </div>
    </div> 
</template>

<script>
export default {
  name: "AppFooter",
  data() {
      return{
            ambiente: process.env.VUE_APP_ENVIROMENT
      };
  },
  props: {
   
  },
};
</script>
<style scoped>

  .footer_fundo {
    background: #335E82;
    width: 100%;
  }
.landing-body .landing-wrapper #footer {
    background: #335E82;
    text-align: left;

}
.landing-body .landing-wrapper #footer .footer-logo {
    height: auto;
    max-width: 95%;
    position: relative;
    padding-left:rem;
    
}

</style>

